/**
 * @file Identity Related Fragments.
 */
import gql from 'graphql-tag';

import { PhotoThumbnails } from './global';
import { SelfieStationAccountDetails } from './account';

export const SelfieStationIdentityDetails = gql`
  fragment SelfieStationIdentityDetails on Identity {
    id
    relationship
    name
    last_name
    has_outdated_selfie
    current_photo {
      ...PhotoThumbnails
    }
    current_matching_photo {
      ...PhotoThumbnails
    }
    account {
      ...SelfieStationAccountDetails
    }
  }

  ${PhotoThumbnails}
  ${SelfieStationAccountDetails}
`;

export const SelfieStationRosterIdentityDetails = gql`
  fragment SelfieStationRosterIdentityDetails on RosterIdentity {
    id
    first_name
    last_name
    email_address
    selfie_photo {
      ...PhotoThumbnails
    }
    linked_identities(slice: { limit: 999 }) {
      total
      records {
        phone_number
        identity {
          id
        }
        account {
          ...SelfieStationAccountDetails
        }
      }
    }
  }

  ${PhotoThumbnails}
  ${SelfieStationAccountDetails}
`;
